export default __webpack_public_path__ + "static/media/pcbImg.a7c782fd.svg";